export default class ClickOffHandler {

    constructor(selector, callback, stopOn = null) {
        this.selector = selector;
        this.callback = callback;
        this.stopOn = stopOn;

        this.handler = null;

        this.setOnFirstClickEvent();
        this.setStopEvent();
    }

    removeListener() {
        document.removeEventListener('click', this.handler);
    }

    setOnFirstClickEvent() {
        document.querySelector(this.selector).addEventListener('click', (event) => {
            this.setClickOffEvent(event.target)
        });
    }

    setClickOffEvent(firstClickTarget) {
        this.handler = (secondClick) => {
            if(firstClickTarget !== secondClick.target) {
                this.callback();
                this.removeListener();
            }
        };

        document.addEventListener('click', this.handler);
    }

    setStopEvent() {
        if(this.stopOn) {
            document.querySelector(this.stopOn).addEventListener('click', (e) => e.stopPropagation());
        }
    }
}